/**
 * The service for all microsoft word related things --> we deal with the dragons :D
 */
// https://github.com/OfficeDev/office-js-docs-pr/blob/master/docs/word/search-option-guidance.md
// https://docs.microsoft.com/en-us/office/dev/add-ins/word/search-option-guidance
import diffService from './diffService'
import HTTP from './httpservice'
import searchService from './searchService'
// import splitService from './splitService'
import Vue from 'vue'
import _ from 'lodash'

const clauseDocumentDao = new HTTP('/document/base64')

const errorHandler = error => {
  console.log(error)
  console.log(`Error ${JSON.stringify(error || '')}`)
  if (error instanceof OfficeExtension.Error) {
    console.log('Debug info: ' + JSON.stringify(error.debugInfo))
  }
}

export default {
  async loadText (context) {
    if (!context) {
      throw new Error('Context not available!')
    }
    const body = context.document.body
    context.load(body, 'text')
    await context.sync()
    return body
  },
  openAndInsertBody (base64Doc) {
    return new Promise((resolve, reject) => {
      Word.run(function (context) {
        console.log('Insert base 64 file')
        // console.log(base64Doc)
        context.application.createDocument(base64Doc).open()
        return context.sync().then(resolve)
      })
    })
  },
  replaceBody (content) {
    return new Promise((resolve, reject) => {
      Word.run(function (context) {
        // Create a proxy object for the document body.
        const body = context.document.body
        console.log(content)
        if (_.isString(content)) {
          // Queue a commmand to insert HTML in to the beginning of the body.
          console.log('Insert ooxml')
          body.insertOoxml(content, 'Replace')
        } else {
          console.log('Insert base 64 file')
          context.application.createDocument(content.base64Doc).open()
          // body.insertFileFromBase64(content.base64Doc, 'Replace')
        }

        // Synchronize the document state by executing the queued commands,
        // and return a promise to indicate task completion.
        return context.sync().then(resolve)
      }).catch(error => {
        errorHandler(error)
        reject(error)
      })
    })
  },
  /**
   * inserts the given content at the specific cursor position
   * @param {*} content as HTML
   */
  insertAt (content = '', type = 'html') {
    const insertFn = type === 'base64' ? 'insertFileFromBase64' : 'insertHtml'
    Word.run(function (context) {
      var selectionRange = context.document.getSelection()
      var paragraph = selectionRange.insertParagraph('', 'Before')
      return context
        .sync()
        .then(res => paragraph[insertFn](content, 'Replace'))
        .then(context.sync)
        .catch(errorHandler)
    }).catch(errorHandler)
  },
  searchAndReplaceClauses (clauses = []) {
    return new Promise((resolve, reject) => {
      Word.run(async context => {
        for (const c of clauses) {
          try {
            const results = context.document.body.search(c.key)
            context.load(results)
            await context.sync()
            const clauseDocument = await clauseDocumentDao.get(c.id).then(res => res.data)
            console.log(clauseDocument)
            results.items.forEach(i => i.insertFileFromBase64(clauseDocument, 'replace'))
            await context.sync()
          } catch (e) {
            errorHandler(e)
          }
        }
        resolve()
      })
    })
  },
  /**
   * searches for the given part in the given searchable
   * @param {*} context the word context
   * @param {*} part the part which should be found
   * @param {*} searchable the searchable. Can be a paragraph or every word related object.
   *                        may also be null, in this case the body object from the context is used (aka. the whole document)
   */
  async searchPart (context, part = '', searchable) {
    const options = {
      matchCase: true,
      ignorePunct: true
    }
    searchable = searchable || context.document.body
    const res = searchable.search(part, options)
    context.load(res, 'items')
    await context.sync()
    return res
  },
  search (clause) {
    const clauseText = clause.rawText
    Vue.$log.info('Clause Raw Text', clauseText)
    const start = searchService.getStartPart(clauseText)
    const end = searchService.getEndPart(clauseText)
    return new Promise((resolve, reject) => {
      Word.run(async context => {
        // const body = await this.loadText(context)
        // const wordParts = splitService.splitText(body.text)
        // const startResult = await searchService.fuzzySearch(wordParts, start)
        // const endResult = await searchService.fuzzySearch(wordParts, end)
        /* if (!(startResult.length && endResult.length)) {
          console.warn('no items for start or end result')
          throw new Error('no items for start or end result')
        } */
        // const foundStart = wordParts[startResult[0].item]
        // const foundEnd = wordParts[endResult[0].item]
        console.log('StartResult', start)
        console.log('EndResult', end)
        const startRange = await this.searchPart(context, start)
        const endRange = await this.searchPart(context, end)
        if (!(startRange.items.length && endRange.items.length)) {
          console.warn('no items for start or end range')
          throw new Error('no items for start or end range')
        }
        console.log('Merge ranges')
        const newRange = startRange.items[0].expandToOrNullObject(
          endRange.items[0]
        )
        if (newRange) {
          context.load(newRange, 'text')
          await context.sync()
          const newRangeText = newRange.text
          Vue.$log.info('New Range text')
          console.log(newRangeText)
          const diff = diffService.difference(newRangeText, clauseText)
          for (const d of diff) {
            const val = d.value.trim()
            const wordOptions = {
              matchCase: true,
              ignorePunct: true
            }
            console.log('Search for', val)
            const res = newRange.search(val, wordOptions)
            if (res) {
              console.log('RES', res)
              context.load(res, 'font')
              await context.sync()
              console.log('Iterate count: ' + res.items.length)
              for (let i = 0; i < res.items.length; i++) {
                // res.items[i].font.color = 'purple'
                res.items[i].font.highlightColor = 'red'
                // res.items[i].font.underline = 'Wave'
              }
              console.log('Finished iterating')
            }
          }
          return context.sync().then(resolve)
        }
      }).catch(e => {
        errorHandler(e)
        reject(e)
      })
    })
  }
}



// WEBPACK FOOTER //
// ./src/service/wordService.js